
    <div class="assessment-status">
        <div class="header">
            <h2 style="margin-bottom: 0 !important;">
                @if (type() == 'WO') {
                National
                } @else if(type() == 'RO') {
                Region {{summaryInfoSelected().region}}
                } @else {
                {{summaryInfoSelected().forest_name}}
                }
            </h2>
            <span class="header-bar">|</span>
            <span class="date">Status as of {{(today | date: 'MM/dd/yyyy')}}</span>
        </div>
    </div>
    <div class="header"><h3>BAER ASSESSMENT STATUS</h3></div>
    <div class="blue-warning" *ngIf="initTab() && !public()">
        <fa-icon [icon]="faCircleInfo" class="faCircleInfo" aria-label="Info"></fa-icon>
        <div class="support-text">
            <b>For more information regarding for a specific fire, please see the <button type="button" (click)="tabChange()" class="link-like">BAER Current Status Report</button>
              or <a [routerLink]="['/fire-tracker']" class="link">Fire Tracker.</a> </b>
        </div>
    </div>
    <div class="blue-warning" *ngIf="!initTab() && !public()">
        <fa-icon [icon]="faCircleInfo" class="faCircleInfo" aria-label="Info"></fa-icon>
        <div class="support-text">
            <b>For more information regarding assessment status details for a specific fire, please see the <a
                    [routerLink]="['/fire-tracker']" class="link">Fire Tracker.</a> </b>
        </div>
    </div>
    <div class="status-list">
        <div class="status-item border-0">
            <mat-chip class="chip-0">
                    <span class="chip-text">{{0 | statusBadge}}</span>
                </mat-chip>
            <div class="status-header">BAER WILDFIRES</div>
            <div class="item">{{summaryInfoSelected().pre_size_up ?? 0}}</div>
            <div class="status-header">NFS ACRES</div>
            <div class="item">{{summaryInfoSelected().fs_acres_pre_size_up ?? 0 | number:'1.0-2'}}</div>
            <div class="status-header">REQUESTED FUNDS</div>
            <div class="item">N/A</div>
            <div class="status-header">AUTHORIZED FUNDING</div>
            <div class="item">N/A</div>
        </div>
        <div class="status-item border-1">
            <mat-chip class="chip-1">
                    <span class="chip-text">{{1 | statusBadge}}</span>
                </mat-chip>
            <div class="status-header">BAER WILDFIRES</div>
            <div class="item">{{summaryInfoSelected().needed ?? 0}}</div>
            <div class="status-header">NFS ACRES</div>
            <div class="item">{{summaryInfoSelected().fs_acres_needed ?? 0 | number:'1.0-2'}}</div>
            <div class="status-header">REQUESTED FUNDS</div>
            <div class="item">N/A</div>
            <div class="status-header">AUTHORIZED FUNDING</div>
            <div class="item">N/A</div>
        </div>
        <div class="status-item border-2">
            <mat-chip class="chip-2">
                    <span class="chip-text">{{2 | statusBadge}}</span>
                </mat-chip>
            <div class="status-header">BAER WILDFIRES</div>
            <div class="item">{{summaryInfoSelected().no_assessment ?? 0}}</div>
            <div class="status-header">NFS ACRES</div>
            <div class="item">{{summaryInfoSelected().fs_acres_no_assessment ?? 0 | number:'1.0-2'}}</div>
            <div class="status-header">REQUESTED FUNDS</div>
            <div class="item">N/A</div>
            <div class="status-header">AUTHORIZED FUNDING</div>
            <div class="item">N/A</div>
        </div>
        <div class="status-item border-3">
            <mat-chip class="chip-3">
                    <span class="chip-text">{{3 | statusBadge}}</span>
                </mat-chip>
            <div class="status-header">BAER WILDFIRES</div>
            <div class="item">{{summaryInfoSelected().in_progress ?? 0}}</div>
            <div class="status-header">NFS ACRES</div>
            <div class="item">{{(summaryInfoSelected().fs_acres_in_progress ?? 0) | number:'1.0-2'}}</div>
            <div class="status-header">REQUESTED FUNDS</div>
            <div class="item">{{'$'+(summaryInfoSelected().requested_funds_in_progress ?? 0 | number:'1.2-2') | empty_check}}</div>
            <div class="status-header">AUTHORIZED FUNDING</div>
            <div class="item">N/A</div>
        </div>
        <div class="status-item border-4">
            <mat-chip class="chip-4">
                    <span class="chip-text">{{4 | statusBadge}}</span>
                </mat-chip>
            <div class="status-header">BAER WILDFIRES</div>
            <div class="item">{{summaryInfoSelected().submitted ?? 0}}</div>
            <div class="status-header">NFS ACRES</div>
            <div class="item">{{(summaryInfoSelected().fs_acres_submitted ?? 0) | number:'1.0-2'}}</div>
            <div class="status-header">REQUESTED FUNDS</div>
            <div class="item">{{'$'+(summaryInfoSelected().requested_funds_submitted ?? 0 | number:'1.2-2') | empty_check}}</div>
            <div class="status-header">AUTHORIZED FUNDING</div>
            <div class="item">{{'$'+(summaryInfoSelected().auth_funds_submitted ?? 0 | number:'1.2-2') | empty_check}}</div>
        </div>
        <div class="status-item border-11">
            <mat-chip class="chip-11">
                    <span class="chip-text">{{11 | statusBadge}}</span>
                </mat-chip>
            <div class="status-header">BAER WILDFIRES</div>
            <div class="item">{{summaryInfoSelected().funding_authorized ?? 0}}</div>
            <div class="status-header">NFS ACRES</div>
            <div class="item">{{(summaryInfoSelected().fs_acres_funding_authorized ?? 0) | number:'1.0-2'}}</div>
            <div class="status-header">REQUESTED FUNDS</div>
            <div class="item">{{'$'+(summaryInfoSelected().requested_funds_funding_authorized ?? 0 | number:'1.2-2') | empty_check}}</div>
            <div class="status-header">AUTHORIZED FUNDING</div>
            <div class="item">{{'$'+(summaryInfoSelected().auth_funds_funding_authorized ?? 0 | number:'1.2-2') | empty_check}}</div>
        </div>
    </div>
    <div class="header"><h3>BAER TEAMS STATUS</h3></div>
    <div class="status-list">
        <div class="status-long-item">
            <div class="status-header">TEAM LEAD ASSIGNED</div>
            <div class="item">{{summaryInfoSelected().team_lead_assigned ?? 0}}</div>
        </div>
        <div class="status-long-item">
            <div class="status-header">STARTING SOON (NEXT 2 WEEKS)</div>
            <div class="item">{{summaryInfoSelected().within_2_weeks ?? 0}}</div>
        </div>
        <div class="status-long-item">
            <div class="status-header">ASSIGNED (PENDING START DATE)</div>
            <div class="item">{{summaryInfoSelected().pending_start_date ?? 0}}</div>
        </div>
        <div class="status-long-item">
            <div class="status-header">SUBMITTED</div>
            <div class="item">{{summaryInfoSelected().submitted ?? 0}}</div>
        </div>
    </div>
